<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <!-- 标题 -->
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="true"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="true"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="true"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 2)" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`"
            :viewMode="true" :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div v-show="form.pricing_id != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(2)" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="true" :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing_id == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>

          <!-- 装/卸货单 -->
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="'formO2Item' + i" :viewMode="true" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <!-- 已完成显示其他重量控件 -->
          <div v-show="form.pricing_id == 1 && detail.isstatus == 4">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="'formItemWeight' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="true"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
          </FormItem>
        </div>

      </el-form>
    </div>

    <div class="btns">
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/cOrder/list" },
        { name: "运单列表", path: "/cOrder/list" },
        { name: "运单添加" },
      ],
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "drtel",
          err: "请填写联系电话",
          type: "text",
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "ertel",
          err: "请填写联系电话",
          type: "text",
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],

      // 运单信息
      formCtrlOrder: [
        {
          label: "计价方式",
          keyName: "pricing_id",
          type: "select",
          options: [],
        },
        {
          label: "运费单价",
          keyName: "cprice",
          err: "请填写运费单价",
          type: "number",
        },
        {
          label: "装货量",
          keyName: "inton",
          err: "请填写装货量",
          type: "text",
        },
        {
          label: "卸货量",
          keyName: "unton",
          err: "请填写卸货量",
          type: "text",
        },
      ],
      kuitonCtrl: {
        label: "亏吨重量",
        keyName: "kuiton",
        err: "请填写亏吨重量",
        type: "text",
        viewMode: true,
      },
      formCtrlOrder2: [
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 1,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 1,
          className: "unton",
        },
      ],

      // 亏吨信息
      formCtrlWeight: [
        {
          label: "计算量",
          keyName: "caton",
          err: "请填写计算量",
          type: "number",
          viewMode: true,
        },
        {
          label: "客担亏吨(吨)",
          keyName: "ceton",
          err: "请填写客担亏吨",
          type: "number",
          viewMode: true,
        },
        {
          label: "亏吨单价(元/吨)",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写默认不计算亏吨金额",
          viewMode: true,
        },
      ],

      // 运单备注
      formCtrl3: [
        {
          label: "运单备注",
          keyName: "order_remark",
          className: "order_remark",
          err: "请填写运单备注",
          // type: "text",
          type: "textarea",
        },
      ],
    };
  },
  methods: {
    setDetailOrderData({ pricing }) {
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'pricing_id' && pricing && pricing.length) {
          c.options = pricing.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        }
      })
    },
  },
  created() { },
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.view {
        .el-form-item__label {
          padding: 0;
        }
      }

      &.first {
        .el-form-item__content {
          width: 300px;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;

  .reject {
    background: #FF4541;
    border-color: #FF4541;
  }

  .examine {
    background: #0fc4b1;
    border-color: #0fc4b1;
  }
}
</style>
